const SCHEDULE_TYPE_LABELS: Record<string, string> = {
  GPS: 'GPS',
  SOLEX_GPS: 'GPS',
  PROXIMITY: 'Proximity',
  VIRTUAL_FENCE: 'VirtualFence',
  COMMUNICATION: 'Communication',
  VHF: 'Beacon',
  BEACON: 'Beacon',
};

const getScheduleLabel = (scheduleType: string): string =>
  SCHEDULE_TYPE_LABELS[scheduleType.toUpperCase()] ?? scheduleType;

const isBeaconSchedule = (scheduleType: string): boolean =>
  ['VHF', 'BEACON'].includes(scheduleType.toUpperCase());

const getOverwriteWarningMessage = (scheduleType: string): string => {
  if (isBeaconSchedule(scheduleType)) {
    return [
      '• <b>Battery:</b> Beacon Schedule changes affect battery life estimates.',
      "• <b>Time Zone:</b> Schedules depend on the collar's UTC correction setting. Contact support if you are unsure.",
      '• <b>Overwrite:</b> This will <b>completely replace</b> your current Beacon schedule (changes are not additive).',
    ].join('<br>');
  }

  const scheduleLabel = getScheduleLabel(scheduleType);

  return [
    `• <b>Battery & Cost:</b> ${scheduleLabel} Schedule changes affect battery life estimates and airtime costs.`,
    "• <b>Time Zone:</b> Schedules depend on the collar's UTC correction setting. Contact support if you are unsure.",
    `• <b>Overwrite:</b> This will <b>completely replace</b> your current ${scheduleLabel} schedule (changes are not additive).`,
  ].join('<br>');
};

export const GENERIC_SCHEDULE_STRINGS = {
  tooltip: {
    permanentRules:
      'Permanent rules should be used for continuous, permanent acquisition and should not be modified frequently.',
    temporaryRules:
      'Temporary, additional rules will allow a acquisition change for a defined period of time and then return to the permanent rule.',
    simultaneousRules:
      'Temporary and permanent rules apply simultaneously. Temporary rules do not suspend permanent rules.',
    questions: 'If you have any questions, please',
    consultManual: 'consult our manual',
    or: 'or',
    contactSpecialist: 'contact one of our specialists',
    consultManualUrl: 'https://www.vectronic-aerospace.com/editing-schedules/',
    contactUrl: 'https://www.vectronic-aerospace.com/support/',
    exportScheduleJson: 'Export Schedule JSON',
  },
  buttons: {
    discardChanges: 'Discard changes',
    removeExistingSchedule: 'Remove existing schedule',
    removeSchedule: 'Remove schedule',
    resetScheduleToFactory: 'Reset schedule to factory',
    addRule: 'Add Rule',
    loadSchedule: 'Load Schedule',
    loadFromTemplate: 'Template',
    loadGpsXFile: 'GPS+X file',
    saveAs: 'Save as',
    saveAsTemplate: 'Template',
    importJson: 'JSON',
    exportJson: 'JSON',
    saveTemplate: 'Save Template',
  },
  warnings: {
    overwriteWarning: (scheduleType: string) => getOverwriteWarningMessage(scheduleType),
    removingScheduleWarning:
      'Warning: Removing this schedule will disable all activity of this schedule type on the collar.',
    removingScheduleDescription: 'This command removes the schedule on the device.',
  },
  errors: {
    scheduleNotAvailable: (allowedCollars: string) =>
      `This schedule is only available for ${allowedCollars}`,
  },
  form: {
    templateNameLabel: 'Template Name',
  },
};
